// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3Ocd_","alertIcon":"ConfirmModal_alertIcon__2gkPx"};